import Cookies from 'js-cookie';
import { useEffect } from 'react';

const EXPIRATION_DURATIONS = [`24h`, `28d`, `10y`];

const handleMGIDCookie = (location) => {
	const key = `seq_mgid_landing`;

	const urlParams = new URLSearchParams(location.search);
	const utmSourceValue = urlParams.get(`utm_source`);

	if (!utmSourceValue || utmSourceValue.toLowerCase() !== `mgid`) {
		return;
	}

	if (Cookies.get(key)) {
		Cookies.remove(key);
	}

	const timeInTheFuture = Math.round(new Date().getTime() / 1000) + 3600 * 24 * 30;
	const cookieArr = [`${location.pathname}${location.search}`, timeInTheFuture];
	const cookieValue = encodeURIComponent(JSON.stringify(cookieArr));

	Cookies.set(key, cookieValue, { expires: 30, path: `/` });
};

const removeLandingCookiesWithDuration = (key) => {
	EXPIRATION_DURATIONS.forEach((durationKey) => {
		const cookieName = `${key}_${durationKey}`;
		Cookies.remove(cookieName);
	});
};

const removeUserAgentCookie = () => {
	/**
	 * This removes the previously used cookie named `COOKIE_NAME_UA`.
	 */
	const COOKIE_NAME_UA = `seq_landing_ua`;
	try {
		removeLandingCookiesWithDuration(COOKIE_NAME_UA);
	} catch (error) {
		console.error(error);
	}
};

const useAppDataHandling = (location) => {
	useEffect(() => {
		handleMGIDCookie(location);
		removeUserAgentCookie();
	}, [location]);
};

export default useAppDataHandling;
